import React, { useEffect, useState, useMemo } from "react";
import { Button, Card, Col, Container, Input, Label, Row, Dropdown, DropdownToggle, DropdownMenu, FormGroup } from "reactstrap";
import { connect } from "react-redux";
import BackButton from "../../../../../../../designUtils/Logo/BackButton.svg";
import GetWorkflowTaskService from "../../../../../../../Service/OPSServices/WorkflowsService/GetWorkflowTaskService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCloudUploadAlt,
    faCloudDownloadAlt,
    faEye,
    faDownload,
    faPaperclip,
    faCheck
} from "@fortawesome/free-solid-svg-icons";
import CustomModal from "../../../../../../Components/Modals/CustomModal";
import SaveTaskDetailsService from "../../../../../../../Service/OPSServices/WorkflowsService/SaveTaskDetailsService";
import GetProgressBarDataService from "../../../../../../../Service/OPSServices/WorkflowsService/GetProgressBarDataService";
import ReactTable from "react-table";
import PriveTab from "../../../../../../../designUtils/Storeoverview/BuildBrand/BrandQuestionair/Prev_Ques_Arrow.svg";
import TaskDetailsComponents from "./TaskDetailsComponents";
import GetAllWorkflowStatusService from "../../../../../../../Service/OPSServices/WorkflowsService/GetAllWorkflowStatusService";
import TaskListDetailsPriviewModeComponents from "./TaskListDetailsPriviewModeComponents";
import GetTaskHistoryDataService from "../../../../../../../Service/OPSServices/WorkflowsService/GetTaskHistoryDataService";
import * as XLSX from 'xlsx';
import notify from '../../../../../../../../src/Notifications/ToastifyActions';
import * as FileSaver from 'file-saver';
import DownloadTaskDataService from "../../../../../../../Service/OPSServices/WorkflowsService/DownloadTaskDataService";
import { SetInnerHtmlWithClassReplacement } from "../../../../../../../Utils/Constants";
import EditIcon from '../../../../../../../designUtils/OpsDashboard/AccountDetails/EditIcon.svg';
import ManageWorkflowsStartDateServices from "../../../../../../../Service/OPSServices/WorkflowsService/ManageWorkflowsStartDateServices";
import PieChart from "../../../../My Tasks/Components/PieChart";

function WorkflowPhasesPage(props) {
    // const [currentPhaseId, setCurrentPhaseId] = useState(props.workflowPhases && props.workflowPhases[0] ? props.workflowPhases[0].id : 0);
    const [currentPhaseId, setCurrentPhaseId] = useState(props.flag == false ? (props.workflowPhases && props.workflowPhases[0]) ? props.workflowPhases[0].id :0 : props.selectedTask && props.selectedTask.phaseId);
    const [taskList, setTaskList] = useState('');
    const [allTasks, setAllTasks] = useState();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [comment, setComment] = useState("");
    const [status, setStatus] = useState("");
    const [workflowPhaseCount, setWorkflowPhaseCount] = useState([]);
    const [totalWorkflowPhaseCount, setTotalWorkflowPhaseCount] = useState();
    const [flag, setFlag] = useState(0);
    const [searchInput, setSearchInput] = useState("");
    const [isOpneTaskListDetails, setIsOpneTaskListDetails] = useState(false);
    const [taskDetails, setTaskDetails] = useState();
    const [statusList, setStatusList] = useState();
    const [isPriviewModeOn, setIsPriviewModeOn] = useState(false);
    const [teamMembers, setTeamMembers] = useState()
    const [member, setMember] = useState()
    const [satusLoading, setSatusLoading] = useState(false)
    const [assignedLoading, setAssingedLoading] = useState(false)
    const [loadding, setLodding] = useState(false);
    const [latestCommentPopup, setLatestCommentPopup] = useState(false);
    const [latestComment, setLatestComment] = useState(false);
    const [isOpenFileListPopup, setIsOpenFileListPopup] = useState(false);
    const [filePath, setFilePath] = useState([])
    const [fileList, setFileList] = useState([])
    const [isOpenFilePopup, setIsOpenFilePopup] = useState(false);
    const [isInitialDirectLoad, setIsInitialDirectLoad] = useState(props.directTaskView);
    const [assignedDropdownOpen, setAssignedDropdownOpen] = useState({});
    const [selectedAssignedTo, setSelectedAssignedTo] = useState({});
    const [isStartDatePopupOpen, setIsStartDatePopupOpen] = useState(false);
    const [selectedStartDate, setSelectedStartDate] = useState("");
    const [tempStartDate, setTempStartDate] = useState("");

    // Pie chart only when opened from Project Dashboard (showStatusPieChart=true)
    const getWorkflowStatusColor = function (status) {
        if (!status) return '#cccccc';
        // Prefer same colors used by status dropdown UI
        const byId = {
            1: '#BDBCBC', // Not Applicable
            2: '#E8E2FF', // Not Started
            3: '#f8ffad', // In Progress
            4: '#FFDDCC', // Postponed
            5: '#D0EFB1', // Completed
            6: '#57b24b', // Signed Off
        };
        if (byId[status.id]) return byId[status.id];

        const name = (status.status || '').toLowerCase();
        if (name === 'not started') return '#E8E2FF';
        if (name === 'completed') return '#D0EFB1';
        if (name === 'in progress') return '#f8ffad';
        if (name === 'not applicable') return '#BDBCBC';
        if (name === 'postponed' || name === 'postpond') return '#FFDDCC';
        if (name === 'signed off') return '#57b24b';
        return status.colourCode || '#cccccc';
    };

    const pieChartData = useMemo(function () {
        if (!props.showStatusPieChart || !statusList || !statusList.length) {
            return { names: [], counts: [], colors: [] };
        }
        const countsById = {};
        statusList.forEach(function (s) {
            countsById[s.id] = 0;
        });
        const notStartedStatus = statusList.find(function (s) {
            return s.status === 'Not Started' || Number(s.id) === 2 || Number(s.id) === 1;
        });
        (allTasks || []).forEach(function (task) {
            const statusId = task.answerObject && task.answerObject[0]
                ? task.answerObject[0].status
                : null;
            if (statusId != null && countsById[statusId] !== undefined) {
                countsById[statusId] += 1;
            } else if (notStartedStatus) {
                countsById[notStartedStatus.id] += 1;
            }
        });
        const withCounts = statusList.filter(function (s) {
            return s.status !== 'Open' && (countsById[s.id] || 0) > 0;
        });
        const source = withCounts.length
            ? withCounts
            : statusList.filter(function (s) { return s.status !== 'Open'; });
        return {
            names: source.map(function (s) { return s.status; }),
            counts: source.map(function (s) { return countsById[s.id] || 0; }),
            colors: source.map(function (s) { return getWorkflowStatusColor(s); }),
        };
    }, [props.showStatusPieChart, statusList, allTasks]);

    useEffect(() => {
        console.log(props.workflowPhases)
        setLodding(true)
        let data = {
            integerId: props.selectedStoreData.integerId,
            workflowMasterId: props.selectedWorkflowMasterId,
            project: props.selectedProjectData ? props.selectedProjectData.projectId : ''
        }
        GetWorkflowTaskService(props.token, data).then((res) => {
            if (res) {

                console.log(res);
                setSelectedStartDate(res.satrtDate)
                setTeamMembers(res.teamMembers)
                setTaskList(res.tasklist);
                setAllTasks(res.tasklist)
                setLodding(false)

                if (props.directTaskView && props.selectedTask) {
                    const specificTask = res.tasklist.find(t => 
                        (props.selectedTask.taskId && t.id === props.selectedTask.taskId) || 
                        (t.taskText === props.selectedTask.task)
                    );
                    
                    if (specificTask) {
                        setTaskDetails(specificTask);
                        setIsOpneTaskListDetails(true);
                        setIsPriviewModeOn(false);
                    }
                }
                setIsInitialDirectLoad(false);
            }
        });
        GetAllWorkflowStatusService(props.token).then((responce) => {
            if (responce) {
                console.log(responce);
                setStatusList(responce.statusList);
            }
        });
        GetProgressBarDataService(props.token, data).then((response) => {
            if (response) {
                console.log(response)
                setWorkflowPhaseCount(response.workflowPhasesCount);
                setTotalWorkflowPhaseCount(response.totalWorkflowPhasesCount);
            }
        });
       
    }, [props.selectedWorkflowMasterId]);
    useEffect(() => {
        if (
            props.flag == false &&
            props.workflowPhases &&
            props.workflowPhases.length > 0
        ) {
    
            const selectedWorkflowPhases = props.workflowPhases.filter(
                phase => phase.WorkflowsMaster == props.selectedWorkflowMasterId
            );
    
            if (selectedWorkflowPhases.length > 0) {
                setCurrentPhaseId(selectedWorkflowPhases[0].id);
            }
        }
    }, [props.workflowPhases, props.selectedWorkflowMasterId]);

    
    const downloadData = () => {
        let data =
        {
            integerId: props.selectedStoreData.integerId,
            workflowMasterId: props.selectedWorkflowMasterId
        }
        DownloadTaskDataService(props.token, data).then((res) => {
            if (res) {
                console.log(res)
                exportToCSVManagedProducts(res.downloadList, props.selectedStoreData.storeName)
            }
        })
    }
    const exportToCSVManagedProducts = (csvData, fileName) => {
        if (!csvData) {
            notify.NotifySuccess('Task data is not available for this store.')
            return true
        }
        // let sheetName = fileName + '_Workflow'
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        console.log(csvData)
        console.log(fileName)
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'Workflow Tasks' : ws }, SheetNames: ['Workflow Tasks'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        console.log('before save')
        FileSaver.saveAs(data, fileName + '_Workflow_' + new Date() + fileExtension);
    };

    const handleSearchInputChange = (e) => {
        setTaskList(allTasks);
        setSearchInput(e.target.value);
        filteredTasktHistory(e.target.value);
    };
    const filteredTasktHistory = (input) => {
        const stringQuery = input.toString();
        if (isPriviewModeOn) {
            if (input !== "") {
                const filtered = allTasks.filter((task) => task.taskText.toLowerCase().includes(stringQuery.toLowerCase()));
                setTaskList(filtered);
            } else {
                setTaskList(allTasks);
            }
        }
        else {
            if (input !== "") {
                const filtered = allTasks.filter((task) => task.taskText.toLowerCase().includes(stringQuery.toLowerCase()));
                if (filtered.length > 0) {
                    setCurrentPhaseId(filtered[0].WorkflowPhases);
                    setTaskList(filtered);
                }
                else {
                    setCurrentPhaseId(0);
                    setTaskList(allTasks); 
                }
            }
            else {
                const defaultPhaseId = (props.workflowPhases && props.workflowPhases.length > 0) 
                                        ? props.workflowPhases[0].id 
                                        : 0;
                                        
                setCurrentPhaseId(defaultPhaseId);
                setTaskList(allTasks);
            }
        }
    };

    const getSimpleDate = (dateStr) => {
        if (!dateStr) return "";
        
        let [year, month, day] = dateStr.split('T')[0].split('-');
    
        if (year && year.length === 2) {
          year = `20${year}`;
        }
    
        return `${year}-${month}-${day}`;
      };

    const handleOpenTaskDetailsPage = (task) => {

        setIsOpneTaskListDetails(true);
        setIsPriviewModeOn(false);
        setTaskDetails(task);
    };
    const handleBackTaskList = () => {
        setIsOpneTaskListDetails(false);
        setIsPriviewModeOn(false);
    };
    const handleStatusChange = (e, task) => {
        setStatus(e.target.value)
        saveTaskDetails('status', e.target.value, task)
    };
    const handleAssignedToChange = (e, task) => {
        setMember(e.target.value)
        saveTaskDetails('assignedTo', e.target.value, task)
    }
    const handlePriviewMode = () => {
        setIsPriviewModeOn(!isPriviewModeOn);
        setIsOpneTaskListDetails(false);
    };


    const normalizeIds = (value) => {
        if (!value) return [];
    
        if (Array.isArray(value)) {
            return value
                .map(v => Number(v))
                .filter(v => Number.isInteger(v) && v > 0);
        }
    
        return [Number(value)].filter(v => Number.isInteger(v) && v > 0);
    };
    const saveTaskDetails = (type, value, taskDetails) => {
        console.log('saveTaskDetails')
        if (!taskDetails) {
            return true;
        }
        const raw =
            value !== undefined && value !== null
                ? value
                : (taskDetails &&
                taskDetails.answerObject &&
                taskDetails.answerObject[0] &&
                taskDetails.answerObject[0].executor
                    ? taskDetails.answerObject[0].executor
                    : []);

        let data;
        setLoading(true)
        // setSatusLoading(taskDetails.id)
        if (type == 'assignedTo') {
            data = {
                taskId: taskDetails.id,
                taskText: 'assignedTo',
                workflowMasterId: props.selectedWorkflowMasterId,
                assignedTo: normalizeIds(raw),
                // assignedTo: value !== undefined ? value : (taskDetails.answerObject[0] ? taskDetails.answerObject[0].executor : 0),
                workflowPhaseId: currentPhaseId,
                integerId: props.selectedStoreData.integerId,
                status: taskDetails.answerObject[0] ? taskDetails.answerObject[0].status : 0,
                attachmentFile: [],
                brand:props.selectedProjectData?props.selectedProjectData.brandId:'',
                project:props.selectedProjectData?props.selectedProjectData.projectId:'',

            }
        }
        else if (type == 'status') {
            data = {
                taskId: taskDetails.id,
                taskText: 'status',
                workflowMasterId: props.selectedWorkflowMasterId,
                assignedTo: taskDetails.answerObject[0] ? taskDetails.answerObject[0].executor : 0,
                workflowPhaseId: currentPhaseId,
                integerId: props.selectedStoreData.integerId,
                status: value ? value : taskDetails.answerObject[0] ? taskDetails.answerObject[0].status : 0,
                attachmentFile: [],
                brand:props.selectedProjectData?props.selectedProjectData.brandId:'',
                project:props.selectedProjectData?props.selectedProjectData.projectId:'',
            }
        }
        else {
            return true
        }
        
        console.log(data)
        // return true

        SaveTaskDetailsService(props.token, data).then((res) => {
            if (res.status) {
                console.log(res)
                setTaskDetails()
                setLoading(false)
                setStatus('')
                setFlag(0)
                setMember()
                setComment('')
                setSelectedFiles([])
                setTaskList(res.tasklist.tasklist)
                setWorkflowPhaseCount(res.progressBarData.workflowPhasesCount);
                setTotalWorkflowPhaseCount(res.progressBarData.totalWorkflowPhasesCount);
                setSatusLoading()
                setAssingedLoading()

            }
        })
    }
    const viewLatestComment = (text) => {
        setLatestCommentPopup(true);
        setLatestComment(text);
    };
    const show = (filelist) => {
        setFileList(filelist)
        if (filelist.length <= 1) {
            filelist.map((files) => {
                if (files.length <= 1) {
                    console.log(files.length)

                    showFile(files[0].filePath)
                }
                else {
                    files.map((file) => {
                        const separatedPath = file.filePath.split("images/");
                        console.log("first");
                        console.log(separatedPath[1]);
                        const ext = separatedPath[1].split(".")[1];
                        console.log(ext);
                        if (ext == "xlsx" || ext == "csv" || ext == "xls" || ext == "docx"|| ext == "doc" || ext == 'xlsm') {
                            setIsOpenFileListPopup(true)
                            setTimeout(() => {
                                setIsOpenFilePopup(false);
                            }, 300);
                        }
                        setIsOpenFileListPopup(true)

                    })
                }
            })
        }
        else {
            setIsOpenFileListPopup(true)
        }


    }

    const showFile = (path) => {
        const separatedPath = path.split("images/");
        console.log("first");
        console.log(separatedPath[1]);
        const ext = separatedPath[1].split(".")[1];
        console.log(ext);
        if (ext == "xlsx" || ext == "csv" || ext == "xls" || ext == "docx"|| ext == "doc" || ext == 'xlsm') {
            setFilePath(path)
            setIsOpenFilePopup(true)
            setTimeout(() => {
                setIsOpenFilePopup(false);
            }, 300);
        }
        setFilePath(path)
        setIsOpenFilePopup(true)
    }
    const stripHtmlTags = (html) => {
        if (!html) return '';
        return html.replace(/<[^>]*>/g, '');
      };
    const downloadFile = async (file) => {
        console.log(file)
        if (true) {
            try {
                let fileName = file.filePath.split('images/')[1]
                fileName = fileName.split('.')[0]
                //  const response = await fetch(file.filePath);
                const response = await fetch(file.filePath, {
                    method: 'GET',
                    //mode: 'no-cors', 
                    referrerPolicy: 'no-referrer', // Set referrerPolicy here
                    cache: 'no-store',
                  });
                if (!response.ok) throw new Error(`Network response was not ok for ${file.id}`);

                const blob = await response.blob();
                const blobUrl = URL.createObjectURL(blob);

                const downloadLink = document.createElement('a');
                downloadLink.href = blobUrl;
                downloadLink.download = fileName || 'downloaded_file';
                // downloadLink.download = 'downloaded_file';

                document.body.appendChild(downloadLink);
                downloadLink.click();

                document.body.removeChild(downloadLink);
                URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error('Failed to download files:', error);
            }
        }
    }

    const fileExtensions = ['csv', 'docx', 'xlsx', 'xls','doc','xlsm'];
    const flattenedFileList = fileList && fileList.flatMap(item => item);
    const gridComments = SetInnerHtmlWithClassReplacement(latestComment);

    const toggleAssignedDropdown = (taskId) => {
        setAssignedDropdownOpen(prevState => ({
            ...prevState,
            [taskId]: !prevState[taskId]
        }));
    };
    
    const handleAssignedCheckboxChange = (taskId, memberId, task) => {
        console.log(memberId)
        let currentSelected = selectedAssignedTo[taskId];

        if (currentSelected === undefined) {
            if (
                task &&
                task.answerObject &&
                task.answerObject.length > 0 &&
                task.answerObject[0].executor
            ) {
                const executor = task.answerObject[0].executor;
                currentSelected = Array.isArray(executor) 
                    ? executor.map(Number) 
                    : [Number(executor)];
            } else {
                currentSelected = [];
            }
        }

        let updatedMembers = [...currentSelected];
        
        const numericMemberId = Number(memberId);

        if (updatedMembers.includes(numericMemberId)) {
            updatedMembers = updatedMembers.filter(id => id !== numericMemberId);
        } else {
            updatedMembers.push(numericMemberId);
        }
        setSelectedAssignedTo(prev => ({
            ...prev,
            [taskId]: updatedMembers
        }));
        saveTaskDetails('assignedTo', updatedMembers, task);
    };
    
    const getSelectedAssignedNames = (taskId, teamMembers = [], task) => {
        let selectedIds = selectedAssignedTo[taskId];
    
        if (selectedIds === undefined) {
            let executor = null;

        if (
            task &&
            task.answerObject &&
            task.answerObject.length > 0 &&
            task.answerObject[0] &&
            task.answerObject[0].executor
        ) {
            executor = task.answerObject[0].executor;
        }
    
            if (Array.isArray(executor)) {
                selectedIds = executor.map(Number);
            } else if (executor) {
                selectedIds = [Number(executor)];
            } else {
                selectedIds = [];
            }
        }
    
        if (!selectedIds.length) {
            return "-- Assigned to --";
        }
    
        // teamMembers not loaded yet
        if (!Array.isArray(teamMembers) || teamMembers.length === 0) {
            return "-- Assigned to --";
        }
    
        const assignedNames = teamMembers
            .filter(member => selectedIds.includes(Number(member.employeeId)))
            .map(member => member.employeeName)
            .join(", ");
    
        return assignedNames || "-- Assigned to --";
    };

    const manageStartDateOfWorkflows = (date) => {
        let data = {
            startDate: date,
            integerId: props.selectedStoreData ? props.selectedStoreData.integerId : "",
            masterWorkflow: props.selectedWorkflowMasterId
        }
        ManageWorkflowsStartDateServices(props.token, data).then((res) => {
            if (res) {
                setTaskList(res.tasks.tasklist || []);
            }
        })
    }

    return (
        <>
            <Card className="pr-3 pl-3 pt-2 pb-2 mb-2 card-of-problemarea mt-3">
                <Row className="align-items-center">
                    <Col md={12}>
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="d-flex align-items-center flex-wrap" style={{ minWidth: 0, flex: '1 1 auto' }}>
                        {!props.hideBackButton && (
                            <button
                                onClick={() => {
                                    props.handleBackButtonToWorkflow();
                                }}
                                className={`hover-btn-link back-btn mr-2 ${isPriviewModeOn?'mb-0':''}`}
                            >
                                <img src={BackButton} alt="not found" />
                            </button>
                            )}
                            <h5 className="mb-0 comment-paragraph-updated-workflow" title={props.selectedStoreData.storeName} style={{cursor:'pointer'}}>
                                <b>{props.selectedStoreData.storeName}</b>
                            </h5>
                            {props.workflowMainCategory &&props.workflowMainCategory.map((workMC) =>
                                workMC.id == props.selectedWorkflowMasterId ? (
                                    <h5 className="mb-0" key={workMC.id}>
                                        &nbsp;:&nbsp;<b>{workMC.name}</b>
                                    </h5>
                                ) : (
                                    ""
                                )
                            )}
                            <div className="d-flex align-items-center ml-4">
                                <h6 className="mb-0 mr-2" style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>Start Date : {selectedStartDate ?selectedStartDate: "--"}</h6>
                                <img 
                                    src={EditIcon} 
                                    alt="Edit" 
                                    style={{ width: "16px", height: "16px", cursor: "pointer", marginRight: "12px" }} 
                                    onClick={() => {
                                        setTempStartDate(getSimpleDate(selectedStartDate));
                                        setIsStartDatePopupOpen(true);
                                    }}
                                />
                                <label className="toggle-switch mb-0 ml-2">
                                    <input type="checkbox" onChange={() => handlePriviewMode()} />
                                    <span className="dot"></span>
                                </label>
                                <p className="custom-label ml-2 mb-0" style={{ whiteSpace: 'nowrap' }}>View All Tasks</p>
                                {isPriviewModeOn ? <button 
                                title='Download taks data'
                                onClick={() => downloadData()} className="btn ml-3 p-0">
                                <FontAwesomeIcon
                                        style={{ cursor: 'pointer',fontSize:'22px'}}
                                        icon={faDownload}
                                        
                                    />
                                </button> : ''}
                            </div>
                            </div>

                            {props.showStatusPieChart ? (
                                <div className="d-flex align-items-center justify-content-end ml-3" style={{ width: '240px', minWidth: '200px', flex: '0 0 auto' }}>
                                    <PieChart
                                        compact
                                        height="90px"
                                        width="240px"
                                        Status={pieChartData.names}
                                        count={pieChartData.counts}
                                        color={pieChartData.colors}
                                    />
                                </div>
                            ) : (
                                <Input
                                    type="text"
                                    value={searchInput}
                                    disabled={loadding ? true : false}
                                    onChange={(e) => handleSearchInputChange(e)}
                                    className="form-control ml-3"
                                    style={{ maxWidth: '260px' }}
                                    placeholder="Search Tasks"
                                />
                            )}
                        </div>
                    </Col>
                </Row>
            </Card>
            <Card className="pr-3 pl-3 pt-1 pb-1 mb-2 card-of-problemarea">
                <Row>
                    <Col md={12} className="p-2">
                        {!isPriviewModeOn ?
                            <div className="d-flex">
                                <>

                                    {props.workflowPhases
                                        ? props.workflowPhases.map((phase) => (
                                            <>
                                                {props.selectedWorkflowMasterId ==
                                                    phase.WorkflowsMaster ? (
                                                    <div
                                                        onClick={() => {
                                                            if (!loadding) {
                                                                setCurrentPhaseId(phase.id);
                                                                setIsOpneTaskListDetails(false);
                                                            }
                                                        }}
                                                        style={{
                                                            cursor: loadding ? "not-allowed" : "pointer",
                                                            opacity: loadding ? 0.5 : 1
                                                        }}
                                                        className={
                                                            phase.id == currentPhaseId
                                                                ? "selected-tab-workflows m-2"
                                                                : "pt-3 pb-3 m-2"
                                                        }
                                                    >
                                                        <p className="text-center p-0 mb-0" style={{ fontSize: '17px' }} key={phase.id}>
                                                            <b>{phase.name}</b>
                                                        </p>
                                                        {workflowPhaseCount
                                                            && workflowPhaseCount.map((count) => (
                                                                <p className="text-center p-0 mb-0">
                                                                    {phase.id === count.WorkflowPhases_id
                                                                        ? count.attemptedTaskCount +
                                                                        " of " +
                                                                        count.taskCount +
                                                                        " Completed"
                                                                        : ""}
                                                                </p>
                                                            ))
                                                        }

                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </>
                                        ))
                                        : ""}
                                </>
                            </div> : <div className="d-flex ml-2">
                                <>
                                    {props.workflowPhases
                                        ? props.workflowPhases.map((phase) => (
                                            <>
                                                {props.selectedWorkflowMasterId ==
                                                    phase.WorkflowsMaster ? (
                                                    <div
                                                        className="selected-tab-workflows-previewmode m-2"
                                                    >
                                                        <p className="text-center p-0 mb-0" style={{ fontSize: '17px' }} key={phase.id}>
                                                            <b>{phase.name}</b>
                                                        </p>
                                                        {workflowPhaseCount
                                                            && workflowPhaseCount.map((count) => (
                                                                <p className="text-center p-0 mb-0 mr-2">
                                                                    {phase.id === count.WorkflowPhases_id
                                                                        ? count.attemptedTaskCount +
                                                                        " of " +
                                                                        count.taskCount +
                                                                        " Completed"
                                                                        : ""}
                                                                </p>
                                                            ))
                                                        }
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </>
                                        ))
                                        : ""}
                                </>
                            </div>}
                    </Col>
                </Row>
            </Card>
            {!isPriviewModeOn ? (
                <>
                    {!isOpneTaskListDetails ? (
                       (props.directTaskView && isInitialDirectLoad) ? (
                            <Card className="card-min-height-workflows card-of-problemarea">
                            </Card>
                        ) : (
                        <Card className="card-min-height-workflows  card-of-problemarea">
                            <Col md={12} className="">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Task</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Assigned To</th>
                                            <th scope="col">Last Update</th>
                                            <th scope="col">Latest Comment</th>
                                            {/* <th scope="col">Attachment</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {taskList &&
                                            taskList.map((task) => (
                                                <>
                                                    {currentPhaseId === task.WorkflowPhases && (
                                                        <tr key={task.taskId}>
                                                             <td
                                                                style={{ cursor: "pointer", width: "25%" }}
                                                                onClick={() => handleOpenTaskDetailsPage(task)}
                                                            >
                                                                <a href="#"><span >
                                                                    {task.taskText?task.taskText:task.taskText==props.selectedTask.task}</span></a>
                                                            </td>

                                                            <td style={{ width: "20%" }}>
                                                                {satusLoading === task.id ? (
                                                                    <p className="mb-0" style={{ color: "#81e94b" }}>Updating..</p>
                                                                ) : (
                                                                    <>
                                                                        {task.answerObject[0] && task.answerObject[0].status === 6 ? (
                                                                            <div className="mt-1">
                                                                                <span className="signedoff-dropdown w-75">
                                                                                    Signed Off &nbsp; &nbsp;
                                                                                    <FontAwesomeIcon style={{ color: "#fff" }} icon={faCheck} />
                                                                                </span>
                                                                                <p className="ml-2 mt-2 mb-0" style={{ color: "#333", fontSize: "13px" }}>
                                                                                {(() => {
                                                                                    let rawName = getSelectedAssignedNames(task.id, task.teamMembers || [], task);
                                                                                    
                                                                                    if (!rawName || rawName === "-- Assigned to --") {
                                                                                        rawName = task.answerObject[0].executorName || task.answerObject[0].updatedByName || "";
                                                                                    }
                                                                                    
                                                                                    if (!rawName) return "";

                                                                                    const names = Array.isArray(rawName)
                                                                                        ? rawName
                                                                                        : rawName.split(",");

                                                                                    return names.map(name => {
                                                                                        const parts = name.trim().split(" ");
                                                                                        return parts.length > 1 && parts[1]
                                                                                            ? `${parts[0]} ${parts[1][0]}.`
                                                                                            : parts[0];
                                                                                    }).join(", ");
                                                                                })()}
                                                                            </p>
                                                                            </div>
                                                                        ) : (
                                                                            <select
                                                                                className={`w-75 ${task.answerObject[0]
                                                                                    ? task.answerObject[0].status === 3
                                                                                        ? "inprogress-dropdown form-control"
                                                                                        : task.answerObject[0].status === 5
                                                                                            ? "completed-dropdown form-control"
                                                                                            : task.answerObject[0].status === 2
                                                                                                ? "notstarted-dropdown form-control"
                                                                                                : task.answerObject[0].status === 1
                                                                                                    ? "notapplicable-dropdown form-control"
                                                                                                    : task.answerObject[0].status === 4
                                                                                                        ? "postpond-dropdown form-control"
                                                                                                        : "form-control"
                                                                                    : "form-control"
                                                                                }`}
                                                                                name="status"
                                                                                id="status"
                                                                                onChange={(e) => {
                                                                                    handleStatusChange(e, task);
                                                                                    setSatusLoading(task.id);
                                                                                }}
                                                                            >
                                                                                <option style={{ background: "#fff" }} value="">
                                                                                    -- Select status --
                                                                                </option>
                                                                                {statusList &&
                                                                                    statusList.map((status) => (
                                                                                        <option
                                                                                            style={{ background: "#fff" }}
                                                                                            key={status.id}
                                                                                            value={status.id}
                                                                                            selected={
                                                                                                status.id === (task.answerObject[0] && task.answerObject[0].status)
                                                                                            }
                                                                                        >
                                                                                            {status.status}
                                                                                        </option>
                                                                                    ))}
                                                                            </select>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </td>

                                        <td style={{ width: "20%" }}>
                                                        {task.answerObject[0] && task.answerObject[0].status === 6 ? (
                                                                <h6 className="ml-2"> 
                                                                    {getSelectedAssignedNames(task.id, task.teamMembers || [], task) !== "-- Assigned to --" 
                                                                        ? getSelectedAssignedNames(task.id, task.teamMembers || [], task) 
                                                                        : (task.answerObject[0].executorName || "")}
                                                                </h6>
                                                                ) : (
                                                                    <>
                                                                        {assignedLoading === task.id ? (
                                                                            <p className="mb-0" style={{ color: "#81e94b" }}>Updating..</p>
                                                                        ) : (
                                                                            <>
                                                                                <Dropdown 
                                                                                    isOpen={assignedDropdownOpen[task.id] || false} 
                                                                                    toggle={() => toggleAssignedDropdown(task.id)} 
                                                                                    className="w-75"
                                                                                >
                                                                                    <DropdownToggle 
                                                                                        caret 
                                                                                        className="form-control d-flex justify-content-between align-items-center"
                                                                                        style={{ backgroundColor: 'white', color: '#495057', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                                    >
                                                                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '90%' }}>
                                                                                        {getSelectedAssignedNames(task.id, task.teamMembers || [], task)}
                                                                                        </span>
                                                                                    </DropdownToggle>
                                                                                    <DropdownMenu 
                                                                                        style={{ 
                                                                                            width: '100%', 
                                                                                            maxHeight: '200px', 
                                                                                            overflowY: 'auto',
                                                                                            padding: '10px' 
                                                                                        }}
                                                                                    >
                                                                                        {task.teamMembers && task.teamMembers.map((member) => (
                                                                                            <FormGroup check key={member.employeeId} className="m-2">
                                                                                                <Label check style={{ cursor: 'pointer', width: '100%' }}>
                                                                                                <Input 
                                                                                                    type="checkbox" 
                                                                                                    checked={(
                                                                                                        selectedAssignedTo[task.id] !== undefined
                                                                                                        ? selectedAssignedTo[task.id]
                                                                                                        : (
                                                                                                            task.answerObject &&
                                                                                                            task.answerObject.length > 0 &&
                                                                                                            task.answerObject[0].executor
                                                                                                            ? (Array.isArray(task.answerObject[0].executor) 
                                                                                                                ? task.answerObject[0].executor.map(Number) 
                                                                                                                : [Number(task.answerObject[0].executor)])
                                                                                                            : []
                                                                                                        )
                                                                                                    ).includes(Number(member.employeeId))}
                                                                                                    onChange={() => handleAssignedCheckboxChange(task.id, member.employeeId, task)}
                                                                                                />
                                                                                                {member.employeeName}
                                                                                                </Label>
                                                                                            </FormGroup>
                                                                                        ))}
                                                                                    </DropdownMenu>
                                                                                </Dropdown>
                                                                                
                                                                                {getSelectedAssignedNames(task.id, task.teamMembers || [], task) !== "-- Assigned to --" && (
                                                                                    <div className="w-75 mx-1 mt-1 marquee-container" style={{ padding: "4px 0" }}>
                                                                                        <div className="marquee-text" style={{ color: "black", fontSize: "13px" }}>
                                                                                            {getSelectedAssignedNames(task.id, task.teamMembers || [], task)}
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </td>

                                                            <td style={{ width: "20%" }}>{task.lastModified}</td>

                                                            <td style={{ width: "20%" }}>
                                                                <p
                                                                    className="m-0 comment-paragraph-workflows"
                                                                    style={{ color: "#3D85C6", cursor: "pointer" }}
                                                                    onClick={() =>
                                                                        viewLatestComment(task.answerObject[0] && task.answerObject[0].memo)
                                                                    }
                                                                    title={stripHtmlTags(task.answerObject[0] && task.answerObject[0].memo)}
                                                                >
                                                                    {stripHtmlTags(task.answerObject[0] && task.answerObject[0].memo)}
                                                                </p>
                                                            </td>

                                                            <td style={{ width: "20%" }}>
                                                                <FontAwesomeIcon
                                                                    className="mr-2"
                                                                    title={task.attachmentList.length == 0 ? 'File not available' : 'Open file'}
                                                                    style={task.attachmentList.length == 0 ? { color: '#c5c3c3' } : { cursor: 'pointer' }}
                                                                    disabled={task.attachmentList.length == 0 ? true : false}
                                                                    icon={faPaperclip}
                                                                    onClick={() => show(task.attachmentList)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )}
                                                </>
                                            ))}
                                    </tbody>

                                </table>
                            </Col>
                        </Card>
                 )
                    ) : (
                        <TaskDetailsComponents
                            selectedProjectData={props.selectedProjectData}
                            taskList={taskList}
                            isOpneTaskListDetails={isOpneTaskListDetails}
                            workflowMainCategory={props.workflowMainCategory}
                            workflowPhases={props.workflowPhases}
                            selectedWorkflowMasterId={props.selectedWorkflowMasterId}
                            currentPhaseId={currentPhaseId}
                            taskDetails={taskDetails}
                            handleBackTaskList={handleBackTaskList}
                            setCurrentPhaseId={setCurrentPhaseId}
                            statusList={statusList}
                            setTaskDetails={setTaskDetails}
                            setTaskList={setTaskList}
                            setAllTasks={setAllTasks}
                            selectedStoreData={props.selectedStoreData}
                            teamMembers={teamMembers}
                            setWorkflowPhaseCount={setWorkflowPhaseCount}
                            setTotalWorkflowPhaseCount={setTotalWorkflowPhaseCount}
                            isMyworksScreen={props.isMyworksScreen}
                        />
                    )}
                </>
            ) : (
                <TaskListDetailsPriviewModeComponents
                    workflowPhases={props.workflowPhases}
                    workflowMainCategory={props.workflowMainCategory}
                    selectedWorkflowMasterId={props.selectedWorkflowMasterId}
                    currentPhaseId={currentPhaseId}
                    taskList={taskList}
                    statusList={statusList}
                    setStatusList={setStatusList}
                    selectedStoreData={props.selectedStoreData}
                    teamMembers={teamMembers}
                    setWorkflowPhaseCount={setWorkflowPhaseCount}
                    setTotalWorkflowPhaseCount={setTotalWorkflowPhaseCount}
                    taskDetails={taskDetails}
                    setTaskList={setTaskList}
                    setAllTasks={setAllTasks}
                    setTaskDetails={setTaskDetails}
                />
            )}
            
            <CustomModal
                header={"Select Start Date"}
                isOpen={isStartDatePopupOpen}
                toggle={() => setIsStartDatePopupOpen(!isStartDatePopupOpen)}
                size={"sm"}
                className='curve-popup'
            >
                <FormGroup>
                <Label>Start Date</Label>
                <Input 
                    type="date"
                    min={new Date().toISOString().split("T")[0]}
                    value={tempStartDate || ""}
                    onChange={(e) => { setTempStartDate(e.target.value); }}
                    />
                </FormGroup>
            
                    <div className="d-flex justify-content-end mt-3">
                        <Button 
                            className="btn-send-approval mr-3"
                            disabled={!tempStartDate}
                        onClick={() => {
                          setSelectedStartDate(tempStartDate);
                          manageStartDateOfWorkflows(tempStartDate);
                          setIsStartDatePopupOpen(false); 
                      }}
                        >
                            Done
                        </Button>
                        <Button
                            color={"link"}
                            onClick={() => setIsStartDatePopupOpen(!isStartDatePopupOpen)}
                        >
                            Cancel
                        </Button>
                    </div>
        </CustomModal>
            <CustomModal
                header={"Latest Comment"}
                isOpen={latestCommentPopup}
                toggle={() => setLatestCommentPopup(!latestCommentPopup)}
                size={"lg"}
                className='curve-popup'
                footer={
                    <>
                        <Button
                            color={"link"}
                            onClick={() => setLatestCommentPopup(!latestCommentPopup)}
                        >
                            Cancel
                        </Button>
                    </>
                }
            >
                <Label>
                    <p className="issue-discription-set" dangerouslySetInnerHTML={{__html : gridComments}}/>
                    {/* <p>{latestComment}</p> */}
                </Label>
            </CustomModal>
            <CustomModal
                header={"Task Attachments List"}
                isOpen={isOpenFileListPopup}
                toggle={() => setIsOpenFileListPopup(!isOpenFileListPopup)}
                size={"md"}
                className='curve-popup'
            >
                <Card>
                    <ReactTable
                        data={flattenedFileList}
                        columns={[
                            {
                                Header: "Name",
                                accessor: "actualFileName",
                                Cell: (cellInfo) => (
                                    <div className="d-flex justify-content-left w-100 text-wrap text-break">
                                        {cellInfo.value}
                                    </div>
                                ),
                            },
                            {
                                Header: "Action",
                                accessor: "filePath",
                                width: 150,
                                Cell: (cellInfo) => (
                                    <div className="d-flex justify-content-center w-100">
                                        {
                                            // fileExtensions.includes(cellInfo.value.split('.')[1]) ? (
                                            fileExtensions.includes(cellInfo.value.split('images/')[1].split('.')[1]) ? (
                                                <FontAwesomeIcon
                                                    className="ml-5"
                                                    style={{ cursor: 'pointer' }}
                                                    icon={faDownload}
                                                    onClick={() => downloadFile(cellInfo.original)}
                                                />
                                            ) : (
                                                <>
                                                    <FontAwesomeIcon
                                                        className="ml-3"
                                                        style={{ cursor: 'pointer' }}
                                                        icon={faEye}
                                                        onClick={() => showFile(cellInfo.value)}
                                                    />
                                                    <FontAwesomeIcon
                                                        className="ml-3"
                                                        style={{ cursor: 'pointer' }}
                                                        icon={faDownload}
                                                        onClick={() => downloadFile(cellInfo.original)}
                                                    />
                                                </>
                                            )
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        getTheadProps={() => {
                            return {
                                style: {
                                    overflowY: "hidden",
                                    background: "#B1FA63",
                                    color: "#243837",
                                },
                            };
                        }}
                        className="-striped -highlight"
                        defaultPageSize={flattenedFileList.length}
                        noDataText="No Attachments available"
                    />
                </Card>
            </CustomModal>
            <CustomModal
                // header={"Task Attachments List"}
                header={<> Attachment
                    <FontAwesomeIcon className="ml-3" style={{ cursor: 'pointer' }} icon={faDownload} onClick={() => downloadFile({ 'filePath': filePath, 'id': 0 })} />
                </>}
                isOpen={isOpenFilePopup}
                toggle={() => setIsOpenFilePopup(!isOpenFilePopup)}
                size={"lg"}
                className='curve-popup'
            >
                <Card>
                    <Col md={12}>
                        <iframe
                            src={
                                filePath ? filePath : ''
                            }
                            title="File Display"
                            width="100%"
                            height="500"
                        ></iframe>

                    </Col>

                </Card>

            </CustomModal>
        </>
    );
}
const mapStateToProps = (state) => {
    return {
        token: state.loggedUser.token,
        accessLevel: state.loggedUser.accessLevel,
        status: state.loggedUser.status,
        error: state.loggedUser.error,
        storeOverview: state.accountOverview.store.storeOverview,
        storeProducts: state.accountOverview.store.storeProducts,
        newUser: state.loggedUser.newUser,
        needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
        user: state.LWA.user,
        isAuth: state.LWA.isAuth,
        enableMobileMenu: state.theme.enableMobileMenu,
        enableClosedSidebar: state.theme.enableClosedSidebar,
        adProfiles: state.accountOverview.landing.adProfiles,
    };
};

export default connect(mapStateToProps)(WorkflowPhasesPage);
